export const baseURLFetch = "https://panel.elmediodemedios.com/backend";
// export const baseURLFetch = "http://localhost:3004";

// Authentication / User management (admin)
// Backend mounts these routes under /api/admin/usersManagement
export const userLoginURL = () => {
  return `${baseURLFetch}/api/admin/usersManagement/login`;
};

export const getUserURL = () => {
  return `${baseURLFetch}/api/admin/usersManagement/me`;
};

export const getUsersURL = () => {
  return `${baseURLFetch}/api/admin/usersManagement/users`;
}

export const postUserURL = () => {
  return `${baseURLFetch}/api/admin/usersManagement/register`;
}

export const putUsersURL = (id) => {
  return `${baseURLFetch}/api/admin/usersManagement/${id}`;
}

export const deleteUserURL = (id) => {
  return `${baseURLFetch}/api/admin/usersManagement/${id}`;
}

//Documentos

export const getDocumentURL = () => {
  return `${baseURLFetch}/api/admin/documents`;
};

export const getDocumentByStatusURL = () => {
  return `${baseURLFetch}/api/admin/documents/status`;
};

export const saveDocumentURL = () => {
  // Admin endpoint for creating documents 
  // POST /api/admin/documents/save
  return `${baseURLFetch}/api/admin/documents/save`;
};

export const updateDocumentURL = () => {
  // Admin endpoint to update documents
  // PUT /api/admin/documents/update
  return `${baseURLFetch}/api/admin/documents/update`;
};

export const desactiveDocumentURL = () => {
  // Admin endpoint to desactive/delete documents
  // PUT /api/admin/documents/active
  return `${baseURLFetch}/api/admin/documents/active`;
};

export const addDocumentUserURL = (userId) => {
  // Admin endpoint to add documents permissions to a user
  // POST /api/admin/userPermissionsManagemet/users/:userId
  return `${baseURLFetch}/api/admin/userPermissionsManagemet/users/${userId}`;
}

export const deleteDocumentUserURL = (userId) => {
  // DELETE /api/admin/userPermissionsManagemet/users/:userId
  return `${baseURLFetch}/api/admin/userPermissionsManagemet/users/${userId}`;
}

export const downloadWordDocumentURL = () => {
  // POST /api/shared/wordDocument
  return `${baseURLFetch}/api/shared/wordDocument`;
};

export const getDocumentTemplatesURL = () => {
  // GET /api/editor/documentTemplates
  return `${baseURLFetch}/api/editor/documentTemplates`;
};

//Secciones

export const getSectionToUserURL = (idDocumento) => {
  // Backend expects query param `id_documento`
  return `${baseURLFetch}/api/admin/sectionsManagement?id_documento=${idDocumento}`;
};

export const getSectionByStatusURL = () => {
  return `${baseURLFetch}/api/admin/sectionsManagement/status`;
};

export const addSectionToUserURL = (documentId) => {
  return `${baseURLFetch}/api/admin/userPermissionsManagemet/documents/${documentId}`;
}

export const deleteSectionToUserURL = (documentID) => {
  // DELETE /api/admin/sectionsManagement?id_section={id}
  return `${baseURLFetch}/api/admin/userPermissionsManagemet/documents/${documentID}`;
}

export const postSectionToDocumentURL = () => {
  return `${baseURLFetch}/api/admin/sectionsManagement`;
}

export const putSectionToDocumentURL = () => {
  return `${baseURLFetch}/api/admin/sectionsManagement`;
};

export const deleteSectionsToDocumentsURL = () => {
  return `${baseURLFetch}/api/admin/sectionsManagement`;
};

export const putActiveSectionToDocumentURL = () => {
  return `${baseURLFetch}/api/admin/sectionsManagement/active`;
};

export const getSectionTypesAdminURL = () => {
  // GET /api/admin/sectionsManagement/type
  // Retorna los tipos de sección activos desde EDITOR_CAT_TIPO_SECCION
  return `${baseURLFetch}/api/admin/sectionsManagement/type`;
};

//Notas

export const getNotesURL = (date, idSection, idDocument) => {
  // Admin notes listing endpoint
  return `${baseURLFetch}/api/admin/noteManagement?fecha=${date}&id_documento=${idDocument}&id_seccion=${idSection}`;
};

export const deleteNoteURL = (id_sintesis) => {
  // Deletion (soft delete) is exposed under client recycling endpoints
  return `${baseURLFetch}/api/client/recyclingOfNotes/delete-note/${id_sintesis}`;
};

export const putRecoverNoteURL = () => {
  return `${baseURLFetch}/api/client/recyclingOfNotes/recover-note`;
};

export const getDeletedNotesURL = (id_documento, fecha) => {
  return `${baseURLFetch}/api/client/recyclingOfNotes/list-note-deleted?fecha=${fecha}&id_documento=${id_documento}`;
};

export const getNotesByArgumentsURL = () => {
  return `${baseURLFetch}/api/editor/filterNotesByArguments`;
};

export const getFilteredNotesURL = () => {
  return `${baseURLFetch}/api/editor/filterNotesByKeyWords`;
};

export const getFilteredNotesByKeywordsURL = () => {
  return `${baseURLFetch}/api/editor/filterNotesByKeyWords/keywords`;
};

export const getFilterNotesByTopicsURL = () => {
  return `${baseURLFetch}/api/editor/filterNotesByTopics`;
};

export const deleteMultipleNotesURL = () => {
  // Ruta del endpoint para eliminar multiples notas
  return `${baseURLFetch}/api/editor/deleteNotes/delete-notes`;
};

// Temas (Themes)
export const getThemesURL = () => {
  return `${baseURLFetch}/api/admin/themes`;
};

// Subtemas (SubThemes)
export const getSubThemesURL = (temaId) => {
  return `${baseURLFetch}/api/admin/themes/${temaId}`;
};

//Editar Sintesis
export const postSynthesisURL = () => {
  return `${baseURLFetch}/api/client/synthesis`;
};

//Editar una nota
export const putUpdateNoteURL = () => {
  return `${baseURLFetch}/api/admin/noteManagement/update-note`;
};

//Note to Section
export const noteToSectionURL = () => {
  // Editor endpoints for transferring notes live under /api/editor/notesTransferToSections
  // Use the 'original' endpoint for non-edited transfer
  return `${baseURLFetch}/api/editor/notesTransferToSections/original`;
};

//Note Edition to Section
export const noteEditionToSectionURL = () => {
  // Use the 'edited' endpoint for transfers that include edited title/synthesis
  return `${baseURLFetch}/api/editor/notesTransferToSections/edited`;
};

//Notes to Section (Multiple)
export const notesToSectionURL = () => {
  // Same as noteToSection but for multiple notes (original content)
  return `${baseURLFetch}/api/editor/notesTransferToSections/original`;
};

//Media List
export const getMediaListURL = () => {
  return `${baseURLFetch}/api/editor/listOfMediums`;
};

//Media Types
export const getMediaTypesURL = () => {
  return `${baseURLFetch}/api/editor/listByTypeMediums`;
};

//Classification
export const getClassificationURL = () => {
  return `${baseURLFetch}/api/editor/listOfClasifications`;
};

//States
export const getStatesURL = () => {
  return `${baseURLFetch}/api/editor/listOfStates`;
};

//Testigos

export const deleteWitnessURL = (id_testigo) => {
  // Backend exposes witness recycle/delete under /api/client/recyclingWitness
  // DELETE /api/client/recyclingWitness/delete-witness/:id_referencia
  return `${baseURLFetch}/api/client/recyclingWitness/delete-witness/${id_testigo}`;
}

export const getDeletedWitnessURL = (id_documento, fecha) => {
  // GET /api/client/recyclingWitness/deleted-witness/:id_documento/:febranch
  // cha
  return `${baseURLFetch}/api/client/recyclingWitness/deleted-witness/${id_documento}/${fecha}`;
};

export const putRecoverWitnessURL = () => {
  // PUT /api/client/recyclingWitness/recover-witness
  return `${baseURLFetch}/api/client/recyclingWitness/recover-witness`;
};

export const putWitnessOrderURL = () => {
  // PUT /api/client/reordenWitness
  return `${baseURLFetch}/api/client/reordenWitness`;
};

//Notas email

export const postSendEmailURL = (idDocument, selectedOption) => {
  // Backend mounts sendEmail under /api/admin/sendEmailManagement/send
  // POST /api/admin/sendEmailManagement/send?id_documento={id}&sendEmail={client|...}
  return `${baseURLFetch}/api/admin/sendEmailManagement/send?id_documento=${idDocument}&sendEmail=${selectedOption}`;
};

//Notas IMG

export const addImgURL = () => {
  // Image upload for notes is handled by the admin module under /api/admin/noteImageManagement
  return `${baseURLFetch}/api/admin/noteImageManagement`;
};

export const editImgURL = () => {
  // PUT /api/admin/noteImageManagement (multipart/form-data)
  return `${baseURLFetch}/api/admin/noteImageManagement`;
};

export const deleteImgURL = (cvcapsula, id_sintesis) => {
  // DELETE /api/admin/noteImageManagement?cvcapsula={}&id_sintesis={}
  return `${baseURLFetch}/api/admin/noteImageManagement?cvcapsula=${cvcapsula}&id_sintesis=${id_sintesis}`;
};

//Notas Estado (Visto)

export const postStatusViewedURL = () => {
  // Client endpoint to toggle note read status
  // POST /api/client/noteView
  return `${baseURLFetch}/api/client/noteView`;
}

//Notas Valoraciones

// Admin valorations are exposed under /api/admin/valorations in the backend
export const addValorationURL = () => {
  return `${baseURLFetch}/api/admin/valorations`;
}

export const deleteValorationURL = (id) => {
  return `${baseURLFetch}/api/admin/valorations/${id}`;
}

//Notas Clipping


export const postDocumentClippingURL = () => {
  return `${baseURLFetch}/api/shared/createClippings/document`;
}

export const postSectionClippingURL = () => {
  return `${baseURLFetch}/api/shared/createClippings/section`;
}

export const postFormatClippingURL = () => {
  // POST to /api/shared/indexFormatClipping
  return `${baseURLFetch}/api/shared/indexFormatClipping`;
}

export const postReplacedClippingURL = () => {
  // POST to /api/shared/replaceBodyClipping
  return `${baseURLFetch}/api/shared/replaceBodyClipping`;
}

export const postGenerateClippingURL = () => {
  return `${baseURLFetch}/api/shared/clippings/generate`;
}


export const getClippingConfigDocumentURL = (id_user) => {
  // Admin configClipping: GET /api/admin/configClipping?user_ID={id_user}
  return `${baseURLFetch}/api/admin/configClipping?user_ID=${id_user}`;
}

export const getClippingConfigSectionURL = (id_user) => {
  // Admin configClipping for sections
  return `${baseURLFetch}/api/admin/configClipping?user_ID=${id_user}&type=Seccion`;
}

export const putClippingConfigURL = (id_config) => {
  return `${baseURLFetch}/api/admin/configClipping/${id_config}`;
}

export const postClippingConfigURL = () => {
  return `${baseURLFetch}/api/admin/configClipping/add`;
}

export const getHiperlyncURL = (type, date) => {
  // Requires authenticated user; returns hyperlinks for given type and fecha
  return `${baseURLFetch}/api/shared/hyperLinkClipping?type=${type}&fecha=${date}`;
}

//Clonación
export const postCloneBetweenDocumentsURL = () => {
  return `${baseURLFetch}/api/admin/cloneNotesBetweenDocuments`;
}

export const postCloneSelectedNotesURL = () => {
  return `${baseURLFetch}/api/editor/cloneNotes/selectedNotes`;
};

export const postCloneMassiveNotesURL = () => {
  return `${baseURLFetch}/api/editor/cloneNotes/allNotes`;
};

export const postCloneMultipleSectionsURL = () => {
  //Clona notas de multiples secciones de un documento a otro documento
  return `${baseURLFetch}/api/editor/cloneNotes/multipleSources`;
};

//Usuarios

export const getUsersFreeURL = () => {
  return `${baseURLFetch}/subscription/free`;
};

export const getUsersStripeURL = () => {
  return `${baseURLFetch}/subscription/stripe`;
};

//Pays

export const getPayURL = (date, idDocument) => {
  // Admin pays endpoint is mounted under /api/admin/pays
  return `${baseURLFetch}/api/admin/pays?fecha=${date}&documento_id=${idDocument}`;
}

export const getAddPayURL = () => {
  return `${baseURLFetch}/api/admin/pays`;
}

export const getUpdatePayURL = (id_pay) => {
  return `${baseURLFetch}/api/admin/pays/${id_pay}`;
}

export const getDeletePayURL = (id_pay) => {
  return `${baseURLFetch}/api/admin/pays/${id_pay}`;
}

//Cartones

export const getCartonURL = (date, idDocument) => {
  return `${baseURLFetch}/api/admin/cartons?fecha=${date}&id_documento=${idDocument}`;
}

export const getAddCartonURL = () => {
  return `${baseURLFetch}/api/admin/cartons`;
}

export const getUpdateCartonURL = (id_carton) => {
  return `${baseURLFetch}/api/admin/cartons/${id_carton}`;
}

export const getDeleteCartonURL = (id_carton) => {
  return `${baseURLFetch}/api/admin/cartons/${id_carton}`;
}

//Indicadores

export const getIndicatorURL = (date, idDocument) => {
  return `${baseURLFetch}/api/admin/indicators?fecha=${date}&id_documento=${idDocument}`;
}

export const getAddIndicatorURL = () => {
  return `${baseURLFetch}/api/admin/indicators`;
}

export const getUpdateIndicatorURL = (id_indicator) => {
  return `${baseURLFetch}/api/admin/indicators/${id_indicator}`;
}

export const getDeleteIndicatorURL = (id_indicator) => {
  return `${baseURLFetch}/api/admin/indicators/${id_indicator}`;
}

//Portadas

export const getPortadaURL = (idDocument) => {
  return `${baseURLFetch}/api/shared/covers/${idDocument}`;
}

export const getAddPortadaURL = () => {
  return `${baseURLFetch}/api/shared/covers`;
}

export const getUpdatePortadaURL = (id_cover) => {
  return `${baseURLFetch}/api/shared/covers/${id_cover}`;
}

export const getDeletePortadaURL = (id_cover) => {
  return `${baseURLFetch}/api/shared/covers/${id_cover}`;
}


//Functionalities

//drag and drop
export const updateOrderNoteURL = () => {
  // Client endpoint for reordering notes
  return `${baseURLFetch}/api/client/reordenNotes`;
};

export const updateOrderSectionURL = () => {
  // Admin endpoint for reordering sections
  return `${baseURLFetch}/api/admin/sectionsManagement/order`;
};

//Editor
export const getTitleURL = (idDocumento) => {
  // Editor endpoints: GET /api/editor/headerDocumentStyles/:documentId
  return `${baseURLFetch}/api/editor/headerDocumentStyles/${idDocumento}`;
};

export const putTitleURL = (idDocumento) => {
  // Editor endpoints: PUT /api/editor/headerDocumentStyles/:documentId
  return `${baseURLFetch}/api/editor/headerDocumentStyles/${idDocumento}`;
};

export const getLogoURL = (idDocumento) => {
  // Editor endpoints: GET /api/editor/logoStyles/:documentId
  return `${baseURLFetch}/api/editor/logoStyles/${idDocumento}`;
};

export const putLogoURL = (idDocumento) => {
  // Editor endpoints: PUT /api/editor/logoStyles/:documentId (multipart/form-data)
  return `${baseURLFetch}/api/editor/logoStyles/${idDocumento}`;
};

export const getFooterURL = (idDocumento) => {
  // Editor endpoints: GET /api/editor/footerStyles/:documentId
  return `${baseURLFetch}/api/editor/footerStyles/${idDocumento}`;
};


export const putFooterURL = (idDocumento) => {
  // Editor endpoints: PUT /api/editor/footerStyles/:documentId (multipart/form-data)
  return `${baseURLFetch}/api/editor/footerStyles/${idDocumento}`;
};

export const getSectionStylesURL = (idDocumento) => {
  // Editor endpoints: GET /api/editor/sectionStyles/:documentId
  return `${baseURLFetch}/api/editor/sectionStyles/${idDocumento}`;
};

export const putSectionStyleURL = (sectionId) => {
  // Editor endpoints: PUT /api/editor/sectionStyles/:sectionId
  return `${baseURLFetch}/api/editor/sectionStyles/${sectionId}`;
};

export const putGlobalSectionStylesURL = (idDocumento) => {
  // Editor endpoints: PUT /api/editor/sectionStyles/:sectionId
  return `${baseURLFetch}/api/editor/sectionStyles/global/${idDocumento}`;
};                                                     

export const getSectionTypesURL = (idDocument) => {
  //Lista los tipos de seccion por documento
  // Editor endpoints: GET /api/editor/sectionTypes/byDocument/:idDocument
  return `${baseURLFetch}/api/editor/sectionsTypes/byDocument/${idDocument}`;
};

export const getAllSectionType = () => {
  //Lista todos los tipo de secciones que existen
  //Editor endpoint: GET /api/editor/sectionsTypes/types
  return `${baseURLFetch}/api/editor/sectionsTypes/types`;
};

export const putSectionTypesURL = (sectionId) => {
  //Actualizar los tipos de seccion
  // Editor endpoints: GET /api/editor/sectionTypes/:sectionId
  return `${baseURLFetch}/api/editor/sectionsTypes/${sectionId}`;
};

export const getMDMDocuments = () => {
  // MDM endpoints: GET /api/mdm/documents
  return `${baseURLFetch}/api/mdm/documents`;
};

export const addWitnessURL = () => {
  //Inserta testigos a una nota
  // Editor endpoints: POST /api/editor/addReferences
  return `${baseURLFetch}/api/editor/addReferences`;
}

// Config Witness Templates
// Obtener la configuración de testigos de un documento
export const getDocumentWitnessConfigURL = (documentId) => {
  // GET /api/shared/configWitnnesTemplates/config/:documentId
  return `${baseURLFetch}/api/shared/witnessConfig/config/${documentId}`;
};

// Guardar (crear/actualizar) la configuración de testigos de un documento
export const saveDocumentWitnessConfigURL = () => {
  // POST /api/shared/configWitnnesTemplates/config
  return `${baseURLFetch}/api/shared/witnessConfig/config`;
};

export const getDateFormaterURL = () => {
  // GET /api/shared/features/engineDateFormet
  return `${baseURLFetch}/api/shared/dateFormats`;
}

// Obtener la configuración de generación de Word de un documento
export const getDocumentConfigURL = (documentId) => {
  // GET /api/shared/documentConfig/config/:documentId
  return `${baseURLFetch}/api/shared/documentConfig/config/${documentId}`;
};

// Guardar (upsert parcial) la configuración de generación de Word de un documento
export const saveDocumentConfigURL = () => {
  // POST /api/shared/documentConfig/config
  return `${baseURLFetch}/api/shared/documentConfig/config`;
};

// Desactivar (delete lógico, FLG_ACTIVE = 0) la configuración de un documento
export const deleteDocumentConfigURL = (documentId) => {
  // DELETE /api/shared/documentConfig/config/:documentId
  return `${baseURLFetch}/api/shared/documentConfig/config/${documentId}`;
};

export const saveJsonURL = () => {
  return `${baseURLFetch}/api/mdm/json/save`;
};

export const publishJsonURL = () => {
  return `${baseURLFetch}/api/mdm/json/publish`;
};

export const getJsonURL = () => {
  return `${baseURLFetch}/api/mdm/json/`;
};

export const syncN8nAudiosURL = () => {
  return `${baseURLFetch}/api/mdm/json/sync-n8n-audios`;
};

export const markerImageURL = () => {
  return `${baseURLFetch}/api/mdm/json/marker-image`;
};